module.exports = __webpack_public_path__ + "img/login_image.4731469b.png";